module.exports = __webpack_public_path__ + "files/520b5d37a2652918d7ef81ce7ba73206.png";